"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _getObjectValue = _interopRequireDefault(require("get-object-value"));
var DISPLAY_NAME = "displayName";
var TYPE = "type";
var getDisplayName = function getDisplayName(el) {
  return (0, _getObjectValue["default"])(el, [DISPLAY_NAME], (0, _getObjectValue["default"])(el, [TYPE, DISPLAY_NAME]));
};
var _default = exports["default"] = getDisplayName;
module.exports = exports.default;